export const linksConfig = {
    DISCORD_LINK: "https://discord.gg/RXBmKSdVRe",
    TWITTER_LINK: "",
    TELEGRAM_LINK: "https://t.me/+elnozTFe3OY0NDA1",
    GITHUB_LINK: "",
    YOUTUBE_LINK: "",
    BLOG_LINK: "",   
};
